import _uniqueId from 'lodash/uniqueId';
import React from 'react';
import I18n from 'i18n-js';
import { ROUTES_V2_PATHS } from 'constants/route-constants';
import { Notification as NotificationGrabUI } from 'grab-ui';
import { NOTIFICATION_TYPE } from 'components/v2/notification/notification';
import { GE_WEB_ORDER_STATE } from 'constants/order-constants';
import { MODE } from 'views/v2/home/constants';

import css from './order-notification.less';

const localePrefix = 'v2.homepage.manualOrder.notification';
export const getSuccessNotification = qty => {
  if (!qty) return null;

  const notificationID = _uniqueId();
  return {
    id: notificationID,
    message: I18n.t(`${localePrefix}.createOrderSuccessful.title`, {
      amt: qty,
      count: qty,
    }),
    // eslint-disable-next-line
    description: history => (
      <span>
        {I18n.t(`${localePrefix}.createOrderSuccessful.description`)}
        <span
          className={css.clickableText}
          onClick={() => {
            NotificationGrabUI.close(notificationID);
            history.push({
              pathname: ROUTES_V2_PATHS.bookings,
              state: { ongoingState: GE_WEB_ORDER_STATE.ActiveDelivery },
            });
          }}
          role="button"
          onKeyDown={null}
          tabIndex="0"
        >
          {I18n.t(`${localePrefix}.createOrderSuccessful.descriptionLink`)}
        </span>
      </span>
    ),
  };
};

export const getFailedConcurrentBookingNotification = message => {
  const notificationID = _uniqueId();
  return {
    id: notificationID,
    type: NOTIFICATION_TYPE.ERROR,
    message: I18n.t(`${localePrefix}.createOrderFailedConcurrentBooking.title`),
    description: message,
  };
};

export const getFailedNotification = (
  qty,
  total,
  errorMsgs,
  isShopify = false,
) => {
  if (!qty) return null;

  const notificationID = _uniqueId();
  return {
    id: notificationID,
    type: NOTIFICATION_TYPE.WARNING,
    message: I18n.t(`${localePrefix}.createOrderFailed.title`, {
      amt: qty,
      total,
      count: qty > 1 && qty < total ? 0 : qty,
    }),
    // eslint-disable-next-line
    description: history => (
      <div className={css.errorNotification}>
        <span>{I18n.t(`${localePrefix}.createOrderFailed.description`)} </span>
        <span
          className={css.clickableText}
          onClick={() => {
            isShopify
              ? history.push({
                  pathname: ROUTES_V2_PATHS.shopifyHome,
                })
              : history.push({
                  pathname: ROUTES_V2_PATHS.home,
                  state: {
                    mode: qty > 1 ? MODE.MULTI_BOOK : MODE.SINGLE_BOOK,
                  },
                });
            NotificationGrabUI.close(notificationID);
          }}
          role="button"
          onKeyDown={null}
          tabIndex="0"
        >
          {I18n.t(`${localePrefix}.createOrderFailed.descriptionLink`)}
        </span>
        <ul>{errorMsgs.map(m => <li key={m}>{m}</li>)}</ul>
      </div>
    ),
  };
};
